import { render } from "./mezaj.vue?vue&type=template&id=9706a9c2"
import script from "./mezaj.vue?vue&type=script&lang=js"
export * from "./mezaj.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/tabibekhanevade-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__